import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dayjs } from 'dayjs';

interface HealthCamp {
    camp_name: string;
    uuid: string;
    slug?: string;
    district?: string;
    camp_type?: string;
    camp_types?: Array<{ id?: number; camp_type: string }>;
}

interface DateRange {
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}
interface CommonFilterState {
    searchTerm: string;
    selectedCamp: HealthCamp | null;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
    status: string | null; 
}
  
const initialState: CommonFilterState = {
    searchTerm: '',
    selectedCamp: null,
    startDate: null,
    endDate: null,
    status: 'ongoing', 
};
  

const commonFilterSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setSearchTerm(state, action: PayloadAction<string>) {
            state.searchTerm = action.payload;
        },
        setSelectedCamp(state, action: PayloadAction<HealthCamp | null>) {
            state.selectedCamp = action.payload;
        },
        setDateRange(state, action: PayloadAction<DateRange>) {
            state.startDate = action.payload.startDate;
            state.endDate = action.payload.endDate;
        },
        setStatus(state, action: PayloadAction<string | null>) {
            state.status = action.payload;
        },
        clearFilters(state) {
            state.searchTerm = '';
            state.startDate = null;
            state.endDate = null;
            state.status = 'ongoing';
        },
    },
});

export const {
    setSearchTerm,
    setSelectedCamp,
    setDateRange,
    clearFilters,
    setStatus,
} = commonFilterSlice.actions;
  

export default commonFilterSlice.reducer;
